import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Layout from "../../components/Layout.js";

const RtoCityMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [Date, setDate] = useState("");
  const [RTOCity, setRTOCity] = useState("");
  const [MainCity, setMainCity] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  const [checkAll, setCheckAll] = useState(false);
  const [checkboxes, setCheckboxes] = useState({
    rtoRate: false,
    rtoTaxSurcharge: false,
    greenTax: false,
    regFee: false,
    hpn: false,
    duplicate: false,
    smartCard: false,
    other: false,
    trc: false,
  });

  useEffect(() => {
    if (!location.state?.editData) return;
    const d = location.state.editData;
    setIsEdit(true);
    setDate(d.sp_331 || "");
    setRTOCity(d.sp_337 || "");
    setMainCity(d.sp_338 || "");
    setCheckboxes({
      rtoRate: d.sp_339 === "Y",
      rtoTaxSurcharge: d.sp_340 === "Y",
      greenTax: d.sp_341 === "Y",
      regFee: d.sp_342 === "Y",
      hpn: d.sp_343 === "Y",
      duplicate: d.sp_344 === "Y",
      smartCard: d.sp_345 === "Y",
      other: d.sp_346 === "Y",
      trc: d.sp_347 === "Y",
    });
  }, [location.state]);

  const handleCheckboxChange = (key) =>
    setCheckboxes((p) => ({ ...p, [key]: !p[key] }));

  const handleCheckAll = () => {
    const v = !checkAll;
    setCheckAll(v);
    setCheckboxes(
      Object.keys(checkboxes).reduce((a, k) => {
        a[k] = v;
        return a;
      }, {}),
    );
  };

  const btn = (bg) => ({
    width: "120px",
    padding: "10px",
    background: bg,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontWeight: "bold",
    cursor: "pointer",
  });
  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "nowrap", // 🔥 no wrapping (forces one row)
    width: "100%",
    marginTop: "30px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "44px",
    padding: "0 18px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  });

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">RTO City Master</div>

          <div className="form-row">
            <div className="form-column">
              <label>Effective From</label>
              <input
                type="date"
                value={Date}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>RTO City *</label>
              <input
                value={RTOCity}
                onChange={(e) => setRTOCity(e.target.value)}
              />
            </div>
            <div className="form-column">
              <label>Main City</label>
              <input
                value={MainCity}
                onChange={(e) => setMainCity(e.target.value)}
              />
            </div>
          </div>
          <br></br>
          {/* ONE-ROW HEADER ALWAYS */}
          <div className="section-header">
            <span className="section-title">RTO Charges Applicable</span>
            <label className="checkall">
              <input
                type="checkbox"
                checked={checkAll}
                onChange={handleCheckAll}
              />
              Check All
            </label>
          </div>

          <div className="grid-outer-container">
            <div className="grid-scroll-container">
              <table className="grid-table">
                <tbody>
                  {Object.keys(checkboxes).map((key) => (
                    <tr key={key}>
                      <td className="charge-name">
                        {key.replace(/([A-Z])/g, " $1")}
                      </td>
                      <td className="check-cell">
                        <input
                          type="checkbox"
                          checked={checkboxes[key]}
                          onChange={() => handleCheckboxChange(key)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div style={buttonContainerStyle}>
            {isEdit && <button style={btn("#2e20ab")}>Update</button>}
            <button
              style={buttonStyle("#ab2025")}
              onClick={() => navigate("/RtoCityMasterGrid")}
            >
              Exit
            </button>
          </div>
        </div>
      </div>

      {/* ================= FINAL CLEAN CSS ================= */}
      <style>{`
* {
  box-sizing: border-box;
}

/* ===== PAGE ===== */
.page-container {
 width: "100%",
    minHeight: "100%",
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 12px;
}

.container {
  width: 100%;
  max-width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 18px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.08);
}

/* ===== HEADER ===== */
.header {
  text-align: center;
  font-size: 1.6rem;
  font-weight: 700;
  padding: 14px;
  background: linear-gradient(90deg, #8B1E3F, #8B1E3F);
  color: #fff;
  border-radius: 6px;
  margin-bottom: 18px;
}

/* ===== FORM GRID ===== */
.form-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 15px;
  margin-bottom: 18px;
}

.form-column {
  display: flex;
  flex-direction: column;
}

.form-column label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}

.form-column input {
  height: 40px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}

/* ===== SECTION HEADER ===== */
.section-header {
  background: #f8bcbc;
  padding: 10px 12px;
  border-radius: 6px 6px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.section-title {
  font-weight: 600;
}

.checkall {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

/* ===== GRID ===== */
.grid-outer-container {
  border: 1px solid #ccc;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
}

.grid-scroll-container {
  max-height: 420px;
  overflow-y: auto;
}

.grid-table {
  width: 100%;
  border-collapse: collapse;
}

.grid-table td {
  padding: 10px;
  border: 1px solid #ddd;
  background: #fff5f5;
}

.charge-name {
  text-align: left;
}

.check-cell {
  width: 80px;
  text-align: center;
}

/* ===== BUTTONS ===== */
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
   position: "relative",
 zIndex: 10
}

.button-container button {
  width: 120px;
  padding: 10px;
  border-radius: 6px;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 992px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .grid-scroll-container {
    max-height: 300px;
  }
}

      `}</style>
    </Layout>
  );
};

export default RtoCityMasterDetailsDesign;
